const animals = [
  { kanji: "麒麟", yomi: "きりん" },
  { kanji: "鼬", yomi: "いたち" },
  { kanji: "駱駝", yomi: "らくだ" },
  { kanji: "鼠", yomi: "ねずみ" },
  { kanji: "栗鼠", yomi: "りす" },
  { kanji: "蜥蜴", yomi: "とかげ" },
  { kanji: "蝙蝠", yomi: "こうもり" },
  { kanji: "獅子女", yomi: "すふぃんくす" },
  { kanji: "馴鹿", yomi: "となかい" },
  { kanji: "犀", yomi: "さい" },
  { kanji: "兎", yomi: "うさぎ" },
  { kanji: "海驢", yomi: "あしか" },
  { kanji: "獺", yomi: "かわうそ" },
  { kanji: "氈鹿", yomi: "かもしか" },
  { kanji: "狐", yomi: "きつね" },
  { kanji: "山椒魚", yomi: "さんしょううお" },
  { kanji: "儒艮", yomi: "じゅごん" },
  { kanji: "獏", yomi: "ばく" },
  { kanji: "猿", yomi: "さる" },
  { kanji: "豹", yomi: "ひょう" },
  { kanji: "蝮", yomi: "まむし" },
  { kanji: "鼫鼠", yomi: "むささび" },
  { kanji: "土竜", yomi: "もぐら" },
  { kanji: "豪猪", yomi: "やまあらし" },
  { kanji: "冬眠鼠", yomi: "やまね" },
  { kanji: "驢馬", yomi: "ろば" },
  { kanji: "騾馬", yomi: "らば" },
  { kanji: "鰐", yomi: "わに" },
  { kanji: "獺虎", yomi: "らっこ" },
  { kanji: "蛙", yomi: "かえる" },
  { kanji: "貉", yomi: "むじな" },
  { kanji: "樹懶", yomi: "なまけもの" },
];

export { animals };
